export const isEvmExtension = (id: string) => {
  return id.includes('evm');
};
